import { Component } from '@angular/core';

@Component({
  selector: 'gplus-icon-cloud-sync',
  imports: [],
  templateUrl: './icon-cloud-sync.component.html',
  styleUrl: './icon-cloud-sync.component.scss',
})
export class IconCloudSyncComponent {

}
